<template>
  <div class="mailAreaBox">
    <div class="listEmptyBox" v-if="$route.name !== 'newRead'">
      <!-- 邮件 -->
      <!--<div class="empty mailEmpty1">-->
      <!--<i class="ico ico-mail-noinfo1"></i>{{$t("wm_lang_html_67596c")}}-->
      <!--</div>-->
      <template v-show="layoutType === 'lr'">
        <div class="empty mailEmpty2" v-show="!selectedMail">
          <i class="ico ico-mail-noinfo2"></i>{{$t("wm_lang_html_c4746d")}}
        </div>
        <div class="empty mailEmpty3" v-show="selectedMail && !selectedOneMail">
          <i class="ico ico-mail-noinfo3"></i><strong>{{$store.getters.acrossSelectCount !== 0 ? $store.getters.acrossSelectCount : $store.getters.checkedMails.length }}</strong>&nbsp;{{$t("wm_lang_html_a00f23")}}
        </div>
      </template>
    </div>
    <div class="readMailBox" v-show="$route.name === 'newRead' || ($route.name === 'read' && selectedOneMail)">
      <div class="mailHead clearfix">
        <div class="mb10" style="overflow:hidden;">
          <div class="fl f18 max-80auto">
            <i style="cursor: pointer" :title="mailContData.starred ? $i18n.t('wm_lang_2f293a') : $i18n.t('wm_lang_5abe91')" @click="setReadStatus(mailContData)" :class="mailContData.starred ? 'el-icon-star-on iconOnYellow' : 'el-icon-star-on'"></i><span class="ml5">{{ mailContData.subject ? mailContData.subject : '('+this.$i18n.t('wm_lang_3b239d')+')' }}</span>
          </div>
          <div class="fr">
            <el-dropdown size="small" trigger="click">
                  <span class="el-dropdown-link f12 c596378">
                    {{$t("custom_lang_0018")}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="printMail(mailContData.mailIndexId)">{{$t("wm_lang_html_e41447")}}</el-dropdown-item>
                <el-dropdown-item @click.native="mailHeadInfo(mailContData.mailIndexId)">{{$t("wm_lang_html_ff1c7d")}}</el-dropdown-item>
                <el-dropdown-item @click.native="mailSaveAsToStream(mailContData.mailIndexId)">
                  {{$t("custom_lang_0019")}}
                </el-dropdown-item>
                <el-dropdown-item @click.native="forwardAsAttach(mailContData.mailIndexId)">{{$t("wm_lang_html_2f78b7")}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="mailInfo f12">
          <!-- 默认 -->
          <div class="flexBetween quickMsg" v-show="!detailAddrs">
            <div class="headPic flexCenter">
              <el-dropdown size="small" trigger="hover" placement="bottom-start" class="mr5">
                <el-link type="primary" :underline="false" class="flexCenter" style="height:45px;"><img class="fl" style="width:45px;height:45px;border-radius:50%;"
                                                                :src="circleUrl"><span class="name pl5 f12 fl c_icon pr cutout max298 fwb">{{ getAddrName(mailContData.from) }}</span></el-link>
                <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
                  <div class="profileTitle" style="height:70px;">
                      <p class="headPic"><img style="width:45px;height:45px;border-radius:50%;" :src="circleUrl"></p>
                      <div class="intro" style="height:66px;width:162px;">
                        <p class="flexBetween"><b class="userName w124 cutout">{{userInfoCard(mailContData.from,'name')}}</b>
                          <!--<el-link href="#" :underline="false"><i class="el-icon-edit f14 rzrq_hide"></i></el-link>-->
                          <a href="javascript:;" :underline="false" @click="writeFor(userInfoCard(mailContData.from,'email'))">{{$t("wm_lang_html_cecc29")}}</a>
                        </p>
                        <p class="wid">{{userInfoCard(mailContData.from,'email')}}</p>
                        <p class="wid" :title="userInfoCard(mailContData.from,'department')">{{userInfoCard(mailContData.from,'department')}}</p>
                      </div>
                  </div>
                  <el-dropdown-item v-if="!currInPers(userInfoCard(mailContData.from,'email'))" @click.native="addContact({name: userInfoCard(mailContData.from,'name'),email: userInfoCard(mailContData.from,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_055692")}}</el-dropdown-item>
                  <el-dropdown-item v-if="currInPers(userInfoCard(mailContData.from,'email'))" @click.native="editContact({name: userInfoCard(mailContData.from,'name'),email: userInfoCard(mailContData.from,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_95b351")}}</el-dropdown-item>
                  <!--<el-dropdown-item>{{$t("wm_lang_html_1c02de")}}</el-dropdown-item>-->
                  <el-dropdown-item @click.native="addBlackList(userInfoCard(mailContData.from,'email'))" style="color:#2081eb;">{{$t("wm_lang_html_2ef722")}}</el-dropdown-item>
                  <!--<el-dropdown-item>{{$t("wm_lang_html_e366cc")}}<i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>-->
                    <!--<div class="el-dropdown-menu-ej">-->
                      <!--<ul class="el-dropdown-menu el-dropdown-menu-right">-->
                        <!--<li class="el-dropdown-menu__item sortDot" @click="addBlackList(userInfoCard(mailContData.from,'email'))">{{$t("wm_lang_html_2ef722")}}</li>-->
                      <!--</ul>-->
                    <!--</div>-->
                  <!--</el-dropdown-item>-->
                </el-dropdown-menu>
              </el-dropdown>
              <!--<span class="name mr5"><el-link type="primary" :underline="false">{{ getAddrName(mailContData.from) }}</el-link></span>-->

            </div>
            <div class="to">{{$t("wm_lang_html_1b1d05")}}</div>
            <div class="getMailName ml5 max-50auto">
              <span v-for="(item, index) in getAllAddrs(mailContData)" v-show="index < 3" class="name"
                    cardmail="yonggang.jin@net263.com">{{ getAddrName(item) }};</span>
              <span class="name">...</span>
            </div>
            <div @click="handleDetailAddrs" class="down mar ml10"><el-button size="mini" style="padding:1px 4px;"><i class="el-icon-arrow-down c596378"></i></el-button></div>
            <div class="right">
              <!--<i title=this.$i18n.t('wm_lang_316206') class="el-icon-time mr5"></i>-->
              <i v-show="currRoute !== 'newRead'" :title="$i18n.t('wm_lang_1e6021')" @click="toNewReadMail(mailContData)" style="cursor: pointer" class="el-icon-copy-document mr5"></i>
              <span class="time c596378">{{formatDate(mailContData.sendDate)}}</span>
            </div>
          </div>
          <div v-show="detailAddrs">
            <!-- 点击后 发送人 -->
            <div class="flexBetween quickMsg">
              <div class="headPic flexCenter">
                <span style="display:inline-block;width:50px;margin-right:3px;">{{$t("wm_lang_html_2df6a3")}}</span>
                <el-dropdown size="small" trigger="hover" placement="bottom-start" class="yx">
                    <span class="toMailAddress bubbleInfo">
                      {{ mailContData.from }}
                      <!--<span class="name">{{$t("wm_lang_html_bbdfe1")}}</span>-->
                      <!--<span class="address">&lt;xu.chen1@net263.com&gt;</span>;-->
                    </span>
                  <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
                    <div class="profileTitle" style="height:70px;">
                        <p class="headPic"><img style="width:45px;height:45px;border-radius:50%;" :src="circleUrl"></p>
                        <div class="intro" style="height:66px;width:162px;">
                          <p class="flexBetween"><b class="userName w124 cutout">{{userInfoCard(mailContData.from,'name')}}</b>
                            <!--<el-link href="#" :underline="false"><i class="el-icon-edit f14 rzrq_hide"></i></el-link>-->
                            <a href="javascript:;" :underline="false" @click="writeFor(userInfoCard(mailContData.from,'email'))">{{$t("wm_lang_html_cecc29")}}</a>
                          </p>
                          <p class="wid">{{userInfoCard(mailContData.from,'email')}}</p>
                          <p class="wid" :title="userInfoCard(mailContData.from,'department')">{{userInfoCard(mailContData.from,'department')}}</p>
                        </div>
                    </div>
                    <el-dropdown-item v-if="!currInPers(userInfoCard(mailContData.from,'email'))" @click.native="addContact({name: userInfoCard(mailContData.from,'name'),email: userInfoCard(mailContData.from,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_055692")}}</el-dropdown-item>
                    <el-dropdown-item v-if="currInPers(userInfoCard(mailContData.from,'email'))" @click.native="editContact({name: userInfoCard(mailContData.from,'name'),email: userInfoCard(mailContData.from,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_95b351")}}</el-dropdown-item>
                    <!--<el-dropdown-item>{{$t("wm_lang_html_1c02de")}}</el-dropdown-item>-->
                    <el-dropdown-item @click.native="addBlackList(userInfoCard(mailContData.from,'email'))" style="color:#2081eb;">{{$t("wm_lang_html_2ef722")}}</el-dropdown-item>
                    <!--<el-dropdown-item>{{$t("wm_lang_html_e366cc")}}<i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>-->
                      <!--<div class="el-dropdown-menu-ej">-->
                        <!--<ul class="el-dropdown-menu el-dropdown-menu-right">-->
                          <!--<li class="el-dropdown-menu__item sortDot" @click="addBlackList(userInfoCard(mailContData.from,'email'))">{{$t("wm_lang_html_2ef722")}}</li>-->
                        <!--</ul>-->
                      <!--</div>-->
                    <!--</el-dropdown-item>-->
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div @click="handleDetailAddrs" class="down mar ml10"><el-button size="mini" style="padding:1px 4px;"><i class="el-icon-arrow-up c596378"></i></el-button></div>
              <div class="right">
                <i v-show="currRoute !== 'newRead'" :title="$i18n.t('wm_lang_1e6021')" @click="toNewReadMail(mailContData)" style="cursor: pointer" class="el-icon-copy-document mr5"></i>
                <span class="time c596378">{{formatDate(mailContData.sendDate)}}</span>
              </div>
            </div>
            <!-- 点击后 收件人 -->
            <div v-if="mailContData.to && mailContData.to.length > 0" class="detailMsg cusLineHeight">
              <span style="display:inline-block;width:50px;">{{$t("wm_lang_html_ac1e1c")}}</span>
              <el-dropdown v-for="(item, index) in mailContData.to" :key="index" size="small" trigger="hover"
                           placement="bottom-start" class="yx">
                <span class="toMailAddress bubbleInfo">
                  {{ item }};
                  <!--<span class="name">{{$t("wm_lang_html_bbdfe1")}}</span>-->
                  <!--<span class="address">&lt;xu.chen1@net263.com&gt;</span>;-->
                </span>
                <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
                  <div class="profileTitle" style="height:70px;">
                      <p class="headPic"><img style="width:45px;height:45px;border-radius:50%;" :src="circleUrl"></p>
                      <div class="intro" style="height:66px;width:162px;">
                        <p class="flexBetween"><b class="userName w124 cutout">{{userInfoCard(item,'name')}}</b>
                          <!--<el-link href="#" :underline="false"><i class="el-icon-edit f14 rzrq_hide"></i></el-link>-->
                          <a href="javascript:;" :underline="false" @click="writeFor(userInfoCard(item,'email'))">{{$t("wm_lang_html_cecc29")}}</a>
                        </p>
                        <p class="wid">{{userInfoCard(item,'email')}}</p>
                        <p class="wid" :title="userInfoCard(item,'department')">{{userInfoCard(item,'department')}}</p>
                      </div>
                  </div>
                  <el-dropdown-item v-if="!currInPers(userInfoCard(item,'email'))" @click.native="addContact({name: userInfoCard(item,'email'), email: userInfoCard(item,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_055692")}}</el-dropdown-item>
                  <el-dropdown-item v-if="currInPers(userInfoCard(item,'email'))" @click.native="editContact({name: userInfoCard(item,'email'), email: userInfoCard(item,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_95b351")}}</el-dropdown-item>
                  <!--<el-dropdown-item>{{$t("wm_lang_html_1c02de")}}</el-dropdown-item>-->
                  <el-dropdown-item @click.native="addBlackList(userInfoCard(item,'email'))" style="color:#2081eb;">{{$t("wm_lang_html_2ef722")}}</el-dropdown-item>
                  <!--<el-dropdown-item>{{$t("wm_lang_html_e366cc")}}<i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>-->
                    <!--<div class="el-dropdown-menu-ej">-->
                      <!--<ul class="el-dropdown-menu el-dropdown-menu-left">-->
                        <!--<li class="el-dropdown-menu__item sortDot" @click="addBlackList(userInfoCard(mailContData.from,'email'))">{{$t("wm_lang_html_2ef722")}}</li>-->
                      <!--</ul>-->
                    <!--</div>-->
                  <!--</el-dropdown-item>-->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- 点击后 抄送人 -->
            <div v-if="mailContData.cc && mailContData.cc.length > 0" class="detailMsg cusLineHeight">
              <span style="display:inline-block;width:50px;">{{$t("wm_lang_html_c00500")}}</span>
              <el-dropdown v-for="(item, index) in mailContData.cc" :key="index" size="small" trigger="hover"
                           placement="bottom-start" class="yx">
                <span class="toMailAddress bubbleInfo">
                  {{ item }};
                  <!--<span class="name">{{$t("wm_lang_html_bbdfe1")}}</span>-->
                  <!--<span class="address">&lt;xu.chen1@net263.com&gt;</span>;-->
                </span>
                <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
                  <div class="profileTitle" style="height:70px;">
                      <p class="headPic"><img style="width:45px;height:45px;border-radius:50%;" :src="circleUrl"></p>
                      <div class="intro" style="height:66px;width:162px;">
                        <p class="flexBetween"><b class="userName w124 cutout">{{userInfoCard(item,'name')}}</b>
                          <!--<el-link href="#" :underline="false"><i class="el-icon-edit f14 rzrq_hide"></i></el-link>-->
                          <a href="javascript:;" :underline="false" @click="writeFor(userInfoCard(item,'email'))">{{$t("wm_lang_html_cecc29")}}</a>
                        </p>
                        <p class="wid">{{userInfoCard(item,'email')}}</p>
                        <p class="wid" :title="userInfoCard(item,'department')">{{userInfoCard(item,'department')}}</p>
                      </div>
                  </div>
                  <el-dropdown-item v-if="!currInPers(userInfoCard(item,'email'))" @click.native="addContact({name: userInfoCard(item,'name'),email: userInfoCard(item,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_055692")}}</el-dropdown-item>
                  <el-dropdown-item v-if="currInPers(userInfoCard(item,'email'))" @click.native="editContact({name: userInfoCard(item,'email'), email: userInfoCard(item,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_95b351")}}</el-dropdown-item>
                  <!--<el-dropdown-item>{{$t("wm_lang_html_1c02de")}}</el-dropdown-item>-->
                  <el-dropdown-item @click.native="addBlackList(userInfoCard(item,'email'))" style="color:#2081eb;">{{$t("wm_lang_html_2ef722")}}</el-dropdown-item>
                  <!--<el-dropdown-item>{{$t("wm_lang_html_e366cc")}}<i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>-->
                    <!--<div class="el-dropdown-menu-ej">-->
                      <!--<ul class="el-dropdown-menu el-dropdown-menu-left">-->
                        <!--<li class="el-dropdown-menu__item sortDot" @click="addBlackList(userInfoCard(mailContData.from,'email'))">{{$t("wm_lang_html_2ef722")}}</li>-->
                      <!--</ul>-->
                    <!--</div>-->
                  <!--</el-dropdown-item>-->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- 点击后 密送人 -->
            <div v-if="mailContData.bcc && mailContData.bcc.length > 0 && mailContIndex.folderId === sendFolderId" class="detailMsg cusLineHeight">
              <span style="display:inline-block;width:50px;">{{$t("wm_lang_html_00237d")}}</span>
              <el-dropdown v-for="(item, index) in mailContData.bcc" :key="index" size="small" trigger="hover"
                           placement="bottom-start">
                <span class="toMailAddress bubbleInfo">
                  {{ item }};
                </span>
                <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
                  <div class="profileTitle" style="height:70px;">
                    <p class="headPic"><img style="width:45px;height:45px;border-radius:50%;" :src="circleUrl"></p>
                    <div class="intro" style="height:66px;width:162px;">
                      <p class="flexBetween"><b class="userName w124 cutout">{{userInfoCard(item,'name')}}</b>
                        <!--<el-link href="#" :underline="false"><i class="el-icon-edit f14 rzrq_hide"></i></el-link>-->
                        <a href="javascript:;" :underline="false" @click="writeFor(userInfoCard(item,'email'))">{{$t("wm_lang_html_cecc29")}}</a>
                      </p>
                      <p class="wid">{{userInfoCard(item,'email')}}</p>
                      <p class="wid" :title="userInfoCard(item,'department')">{{userInfoCard(item,'department')}}</p>
                    </div>
                  </div>
                  <el-dropdown-item v-if="!currInPers(userInfoCard(item,'email'))" @click.native="addContact({name: userInfoCard(item,'name'),email: userInfoCard(item,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_055692")}}</el-dropdown-item>
                  <el-dropdown-item v-if="currInPers(userInfoCard(item,'email'))" @click.native="editContact({name: userInfoCard(item,'email'), email: userInfoCard(item,'email')})" style="color:#2081eb;">{{$t("wm_lang_html_95b351")}}</el-dropdown-item>
                  <el-dropdown-item @click.native="addBlackList(userInfoCard(item,'email'))" style="color:#2081eb;">{{$t("wm_lang_html_2ef722")}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div v-if="strangerRemindFlag" class="el-alert el-alert--warning is-light" style="margin-bottom:5px;">
        <div class="el-alert__content">
          <span class="el-alert__title">{{$t("wm_lang_html_f48072")}}</span>
          <span class="el-alert__title">{{$t("wm_lang_html_88f1fc")}}</span>
          <span class="el-alert__title">{{ mailContData.realSender }}</span>
          <span class="el-alert__title">{{$t("wm_lang_html_9ab2e7")}}</span>
          <span class="el-alert__closebtn" style="top:8px;">
            <a href="javascript:;" @click="trustContact({email: mailContData.realSender})">{{$t("wm_lang_html_ba8713")}}</a> |
            <a href="javascript:;" @click="rejectContact(mailContData.realSender)">{{$t("wm_lang_html_2ef722")}}</a>
          </span>
          <!--<i class="el-alert__closebtn el-icon-close"></i>-->
        </div>
      </div>
      <div v-if="mailIsInstead" class="el-alert el-alert--warning is-light" style="margin-bottom:5px;">
        <div class="el-alert__content">
          <span class="el-alert__title">{{$t("wm_lang_html_0eab0c")}}</span>
          <span class="el-alert__title">{{$t("wm_lang_html_d8b930")}}</span>
          <span class="el-alert__title">{{ mailContData.realSender }}</span>
          <span class="el-alert__title">{{$t("wm_lang_html_961cac")}}</span>
          <!--<i class="el-alert__closebtn el-icon-close"></i>-->
        </div>
      </div>
      <div v-if="decryptShow" class="el-alert el-alert--warning is-light" style="margin-bottom:5px;">
        <div class="el-alert__content">
          <div class="el-alert__title fwb">{{$t("custom_lang_0003")}}</div>
          <div class="flexCenter mt5">
            <span>{{$t("custom_lang_0004")}}</span>
          </div>
          <div class="flexCenter mt5">
            <span>{{$t("custom_lang_0049")}}</span>
            <el-input v-model="encryptPasswd" size="mini" class="mr5 ml5" style="width:200px;"></el-input>
            <el-button type="primary" size="mini" @click="decryptMail">{{$t("wm_lang_38cf16")}}</el-button>
          </div>
        </div>
      </div>
      <div class="encryption" v-if="!decryptShow && showPasswordTips">
        <div class="lable">{{$t("comm_lang_0025")}}：</div>
        <div class="text">
          <span v-show="showPassword">{{mailPassword}}</span><span v-show="!showPassword" @click="showMailPw">{{$t("comm_lang_0055")}}</span><span  v-show="showPassword" @click="hideMailPw">{{$t("comm_lang_0056")}}</span>
        </div>
      </div>
      <div v-if="!decryptShow && decryptTips" class="el-alert el-alert--warning is-light" style="margin-bottom:5px;">
        <div class="el-alert__content">
          <div class="el-alert__title">{{$t("comm_lang_0062")}}</div>
        </div>
      </div>
      <div class="mailStateBar" v-if="showRacallAllSuccess">
        <span class="lable">{{$t("comm_lang_0040")}}：</span>
        <span class="text">{{$t("wm_lang_html_cdd451")}}</span>
      </div>
      <div class="mailStateBar" v-if="showRacallAllFail">
        <span class="lable">{{$t("comm_lang_0040")}}：</span>
        <span class="text">{{$t("comm_lang_0035")}}</span>
      </div>
      <div class="mailStateBar" v-if="showRacallPartSuccess">
        <span class="lable">{{$t("comm_lang_0040")}}：</span>
        <span class="text">{{$t("comm_lang_0042")}}</span>
      </div>
      <div v-if="!decryptShow" class="mailBody mailTxt">
        <div class="attachList" v-if="mailContData.attachInfos && mailContData.attachInfos.length !== 0">
          <div class="attachTit">
            <h2><b>{{$t("wm_lang_html_713272")}}</b> {{$t("wm_lang_html_374237")}}<span class="attNum">{{mailContData.attachInfos.length}}</span>{{$t("wm_lang_html_dfe48d")}}<a :href="attachDownUrl(mailContData.multiAttachDownUrl)"
                                                               target="_blank" id="downLoadAllLink">{{$t("wm_lang_html_a2247c")}}</a>{{$t("wm_lang_html_0611d8")}} </h2>
          </div>
          <ul class="attachCont" v-for="(item, i) in mailContData.attachInfos">
            <li class="clearfix">
              <div class="left float-l">
                <a :href="attachDownUrl(item.downUrl)" class="getTime" target="_blank"> <span
                  :class="'icon ' + matchAttachIcon(item.fileName)" :name="item.fileName"></span> <span
                  class="txt">{{ item.fileName }} ({{ bytesToSize(item.size) }})</span> </a>
              </div>
              <div class="right float-r">
                <a href="javascript:;" v-if="configSetting.deliverSetting.previewServerOnOff === '1'" class="rzrq_hide" @click="attachPreview(item)" target="_self">{{$t("wm_lang_html_8b6aed")}}</a>
                <a :href="attachDownUrl(item.downUrl)" class="getTime" target="_blank">{{$t("wm_lang_html_f26ef9")}}</a>
              </div>
            </li>
          </ul>
        </div>

        <div class="mailCont">
          <div id="mailTextWrapper" class="mailText f14" v-html="mailContData.mailText"></div>
        </div>

      </div>

      <div id="quickReplyWrapper" class="mailForm mt20 pb30" v-if="quickReplyEnable">
        <el-form ref="form" :model="form" size="mini">
          <el-form-item>
            <el-input @keyup.native="quickReplyWrite" type="textarea" :rows="quickReplyHeigh ? '3' : '1'" :placeholder="$i18n.t('wm_lang_69e94f')" v-model="form.desc" @focus="quickReplyFocus" resize="none"></el-input>
          </el-form-item>
          <el-form-item v-show="showQuickReply">
            <el-button type="primary" @click.stop="quickReply">{{$t("wm_lang_html_1535fc")}}</el-button>
            <el-button @click.stop="cancelQuickReply">{{$t("wm_lang_html_625fb2")}}</el-button>
            <el-checkbox :label="$i18n.t('wm_lang_6e7b20')" v-model="form.only" name="type" class="ml10"></el-checkbox>
          </el-form-item>
        </el-form>
      </div>

    </div>

    <!-- 查看信头弹框元素 -->
    <el-dialog :title="$i18n.t('wm_lang_ff1c7d')" :visible.sync="mailHeadDialogVisible" :close-on-click-modal="false" width="200">
      <span v-html="mailHeadInfoStr"></span>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="mailHeadDialogVisible = false">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>
    </span>
    </el-dialog>
    <!-- 查看信头弹框元素 -->
  </div>

</template>

<script>
import Cookies from 'js-cookie';
import xmail from '@/api/api';
import {bytesToSize, matchAttachIcon, formatDate, downloadFile, emailPart, belongRootFolderId} from '@/utils/utils';
import baseUrl from "../../../api/baseUrl";
import axios from "axios";
import storeLocal from 'store';
import _ from "lodash";
import TreeUtil from "../../core/tree/TreeUtil";
import OrgContacts from "../../core/common/OrgContacts";
import Algorithm from "../../core/common/Algorithm";
import BaseContactTree from "../../core/common/BaseContactTree";
import {sendMailErrorAlert} from '@/utils/sendMailAlert';

export default {
    name: 'mailAreaBox',
    mixins: [BaseContactTree],
    data() {
        return {
            msgindex: this.$i18n.t('wm_lang_062ebd'),
            configSetting: {},
            mailHeadDialogVisible: false,
            mailHeadInfoStr: '',
            mailId: '',
            fileId: '',
            mailContData: {},
            mailContIndex: {},
            allAddrs: [],
            detailAddrs: false,
            quickReplyHeigh: false,
            showQuickReply: false,
            quickReplyEnable: true,
            layoutType: Cookies.get('Pwm-set-layout') ? Cookies.get('Pwm-set-layout') : 'lr',
            sendFolderId: xmail.enums.FolderType.SEND_BOX_FOLDER_ID,
            // unReadMail: false,
            form: {
                desc: '',
                only: false
            },
            circleUrl: require('@/assets/images/3ea6beec64369c2642b92c6726f1epng.png'),
            mailIsInstead: false,
            disablePersContact: true,
            strangerRemindFlag: false,
            localUserInfo: {},
            decryptShow: false,
            decryptTips: false,
            showPasswordTips: false,
            encryptPasswd: '',
            mailPassword: '',
            showPassword: false,
            showRacallAllSuccess: false,
            showRacallAllFail: false,
            showRacallPartSuccess: false
        }
  },
  methods: {
    handleCommand(command) {
      this.$message('click on item ' + command);
    },
    showMailPw() {
      // this.showPassword = true;
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.MailFile.getEncryptMailPasswdParamBuilder();
        pm.mailIndexId = self.mailContData.mailIndexId;
        api.MailFile.getEncryptMailPasswd(pm, function (res) {
          // console.log(res);
          if(res.data.code === 0) {
            self.showPassword = true;
            self.mailPassword = res.data.data.mailPasswd;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    hideMailPw() {
      this.showPassword = false;
    },
    decryptMail() {
      // console.log(this.encryptPasswd);
      if(this.encryptPasswd) {
        this.getMailCont()
      } else {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('comm_lang_0060')
        })
      }
    },
    trustContact(trustAddr) {
      this.$router.push({name: 'address', params: {type: 'addAddr',addr: trustAddr}});
    },
    rejectContact(rejAddr) {
      this.$confirm(`${this.$i18n.t('custom_lang_0050')}${rejAddr}${this.$i18n.t('custom_lang_0051')}`, this.$i18n.t('wm_lang_c45357'), {
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Blacklist.addBlacklistAddrParamBuilder();
          pm.blackAddr = emailPart(rejAddr, 'email');
          api.Blacklist.addBlacklistAddr(pm, function (res) {
            if(res.data.code === 0) {
              console.log(res.data);
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_3fdaea')
              })
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }).catch(() => {
        //
      });
    },
    setReadStatus(mail) {
      // return;
      let self = this;
      let mailId = mail.mailIndexId;
      let mailStar = mail.starred;
      (function (api, enums, pms) {
        let pm = pms.Index.setMailStatusParamBuilder();
        pm.mailIndexIds = [mail.mailIndexId];
        let opType = '';
        let opTypeVal = false;
        if(mailStar === false) {
          opType = enums.MailStatus.STAR;
          opTypeVal = true;
        }
        if(mailStar === true) {
          opType = enums.MailStatus.DE_STAR;
          opTypeVal = false;
        }
        pm.targetMailStatus = opType;
        api.Index.setMailStatus(pm, function (res) {
          // console.log(res)
          if(res.data.code === 0){
            let indexList = self.$store.getters.indexListData;
            let newList = indexList.map((item) => {
              if(mailId === item.mailIndexId){
                // console.log(item.id)
                item.starred = opTypeVal
              }
              return item
            });
            self.$store.commit('SET_INDEX_DATA',newList);
            self.$EventBus.$emit("refreshFolders");
            self.mailContData.starred = opTypeVal;
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    addBlackList(rejAddr) {
      this.$confirm(`${this.$i18n.t('custom_lang_0050')}${rejAddr}${this.$i18n.t('custom_lang_0051')}`, this.$i18n.t('wm_lang_c45357'), {
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Blacklist.addBlacklistAddrParamBuilder();
          pm.blackAddr = rejAddr;
          // pm.blackAddrMatchType = 1; // //不用前端传后端写
          api.Blacklist.addBlacklistAddr(pm, function (res) {
            if(res.data.code === 0) {
              console.log(res.data);
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_3fdaea')
              })
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }).catch(() => {
        //
      });
    },
    quickReplyWrite() {
      if(this.form.desc !== '') {
        this.showQuickReply = true;
        this.quickReplyHeigh = true;
      } else {
        // this.showQuickReply = false;
        // this.quickReplyHeigh = false;
      }
    },
    cancelQuickReply() {
      this.form.desc = '';
      this.showQuickReply = false;
      this.quickReplyHeigh = false;
    },
    quickReply() {
      //------快捷回复--------
      let self = this;
      (function (api, enums, pms) {
        let spm = pms.MailFile.quickSendMailParamBuilder();
        let userInfo = storeLocal.get('Pwm-userInfo');
        spm.from = userInfo.userEmail;
        spm.to = [self.mailContData.from];
        if(!self.form.only) {
          spm.to = self.mailContData.to;
          spm.to.push(self.mailContData.from);
          spm.cc = self.mailContData.cc;
          let pattern = userInfo.userEmail;
          spm.to = _.filter(spm.to, function(item) {
            return !_.includes(item, pattern);
          });
          spm.cc = _.filter(spm.cc, function(item) {
            return !_.includes(item, pattern);
          });
          // spm.bcc = self.mailContData.bcc;
        }
        spm.subject = 'Re:'+ self.mailContData.subject;
        spm.text = self.form.desc;
        spm.contentType = "";
        spm.sendMailType = enums.SendMailType.QUICK;
        spm.mailIndexId = '';
        // spm.replyPreviousMailIndexId = self.mailContData.mailIndexId;
        spm.replyPreviousMailStatus = {
          mailIndexId: self.mailContData.mailIndexId,
          mailStatus: {answered: self.mailContIndex.answered, forwarded: self.mailContIndex.forwarded, seen: self.mailContIndex.seen}
        };
        spm.mailOperatorType = enums.MailOperatorType.REPLY;
        spm.priority = enums.MailPriority.NORMAL;
        // console.log(spm)
        // return;
        api.MailFile.quickSendMail(spm, function (res) {
          // console.log(res)
          if (res.data.code === 0) {
            self.$message({
              type: 'success',
              message: self.$i18n.t('wm_lang_ac9f45')
            });
          }
          // WM -> SMTP{{$t("wm_lang_html_ec0bce")}}(2851~2900)
          else if ((res.data.code >= 2051 && res.data.code <= 2060) || (res.data.code >= 2851 && res.data.code <= 2900)) {
            sendMailErrorAlert(res);
          }
          self.form.desc = '';
          self.showQuickReply = false;
          self.quickReplyHeigh = false;
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    quickReplyFocus() {
      this.showQuickReply = true;
      this.quickReplyHeigh = true;
    },
    // quickReplyBlur() {
    //   if(this.form.desc === '') {
    //     // this.showQuickReply = false;
    //     this.quickReplyHeigh = false;
    //   }
    // },
    handleDetailAddrs() {
      this.detailAddrs = !this.detailAddrs
    },
    getAllAddrs(data) {
      if (!(data.to || data.cc || data.bcc)) {
        return
      }
      let allAddrs = [...data.to, ...data.cc, ...data.bcc];
      return allAddrs;
    },
    getAddrName(addr) {
      if (!addr) {
        return
      }
      let name = addr.split('<')[0];
      return name;
    },
    addContact(addr) {
      this.$router.push({name: 'address', params: {type: 'addAddr',addr: addr}});
    },
    editContact(addr) {
      this.$router.push({name: 'address', params: {type: 'editAddr',addr: addr}});
    },
    currInPers(addrEmail) {
      let persInfo = storeLocal.get('ls_pers_info') ? storeLocal.get('ls_pers_info') : [];
      // console.log(persInfo);
      return persInfo.find(item => { return item.email === addrEmail });
    },
    printMail(mid) {
      storeLocal.set('ls_print_mail', this.mailContData);
      const{ href } = this.$router.resolve({name:"PrintMail",query:{mailId: mid}});
      window.open(href,'_blank');
    },
    forwardAsAttach(mid) {
      this.$router.push({name: 'write', params: {type: 'forwardMultiple', mid: mid}});
    },
    toNewReadMail(item) {
      // console.log(item);
      //后端读信接口暂未提供fileId，新开页签从checkedMails中获取fileId
      this.$router.push({name: 'newRead', params: {id:item.mailIndexId, fileId:item.fileId, folderId: item.folderId, read:item.seen, tit:item.subject},query: { t: Date.now() }});
    },
    /**
     * 获取邮件内容
     **/
    getMailCont() {
      // console.log(this.$route.query)
      // console.log(this.$route.params)
      // console.log(this.$store.getters.checkedMails)
      this.detailAddrs = false;
      this.showPassword = false;
      //初始快捷回复
      this.form.only = false;
      this.cancelQuickReply();
      let checkedMailId = '';
      let checkedFileId = '';
      if(this.$store.getters.checkedMails.length === 1) {
        checkedMailId = this.$store.getters.checkedMails[0].mailIndexId
        checkedFileId = this.$store.getters.checkedMails[0].fileId
      }
      if (!checkedMailId && !this.$route.params.isAnnounce) { //初次加载邮件索引显示未选，并且不是首页点击公告时，不读取邮件
        // this.unReadMail = true;
        return;
      }

      // this.mailId = this.$route.params.id;
      this.mailId = checkedMailId;
      this.fileId = checkedFileId;
      let mailRead = this.$route.params.read; //已读未读
      let isClickMsg = this.$route.params.isClickMsg; //是否单点读信
      // console.log(this.mailId)
      let loading;
      if(document.querySelector('.mailAreaBox')) {
        loading = this.$loading({text: this.$i18n.t('wm_lang_f013ea'), target: document.querySelector('.mailAreaBox')});
      } else {
        loading = this.$loading({text: this.$i18n.t('wm_lang_f013ea'), target: document.querySelector('#mainLayoutBox')});
      }
      let self = this;
      (function (api, enums, pms) {
        let mId = self.$route.params.id ? self.$route.params.id : self.mailId;
        // let mId = this.mailId;
        // let fId = self.$store.state.folder.folderId;
        let fId = self.$route.params.folderId;
        let fileId = self.$route.params.fileId ? self.$route.params.fileId : self.fileId;
        let rpm = pms.MailFile.getMailInfoParamBuilder();
        rpm.mailIndexId = mId;
        rpm.fileId = fileId;
        // rpm.folderId = fId;
        rpm.mailStatus = enums.MailStatus.UNREAD
        if (mailRead === true) {
          rpm.mailStatus = enums.MailStatus.READ
        }
        if (isClickMsg === true) {
          rpm.isClickMsg = true
        }
        //邮件解密密码
        if (self.encryptPasswd) {
          rpm.mailPasswd = self.encryptPasswd
        }
        // 获取邮件
        api.MailFile.getMailInfo(rpm, function (res) {
          console.log("------------------- -------------------")
          console.log(res);
          if(!res.data.data) {
            // console.log(self.mailContData)
            // console.log(self.mailContIndex)
            self.mailContData = {};
            self.mailContIndex = {};
            self.$store.commit('SET_MAIL_DATA', {});
            self.$store.commit('SET_MAIL_INDEX', {});
            self.mailIsInstead = false;
            self.strangerRemindFlag = false;
            loading.close();
            return;
          }
          if(res.data.data.code === enums.ErrorCode.WM_READ_NO_HAS_PASSWORD_ERROR || res.data.data.code === enums.ErrorCode.WM_READ_DECRYPT_MAIL_ERROR) {
            self.decryptShow = true;
            if(res.data.data.code === enums.ErrorCode.WM_READ_DECRYPT_MAIL_ERROR) {
              self.$message({
                type: 'warning',
                message: self.$i18n.t('custom_lang_0034')
              });
              self.encryptPasswd = '';
            }
          } else {
            self.decryptShow = false;
            self.encryptPasswd = '';
          }

          if(res.data.code === 0){
            let mailData = res.data.data.mailInfo;
            let mailIndex = res.data.data.mailIndex;
            // let mailFullData = {mailIndex: res.data.data.mailIndex, mailData: res.data.data.mailInfo};
            console.log(mailData);
            console.log(mailIndex);

            // self.localUserInfo = storeLocal.get('Pwm-userInfo');
            let mailIndexFolderId = belongRootFolderId(mailIndex.folderId, self.$store.getters.folders);
            //加密邮件状态提示标识
            self.decryptTips = res.data.data.mailIndex.encryptId && (res.data.data.mailIndex.attrFlag & xmail.flags.MailIndexAttrFlag.DECRYPT_VAL) !== 0 && mailIndexFolderId !== enums.FolderType.DRAFT_BOX_FOLDER_ID && mailIndexFolderId !== enums.FolderType.SEND_BOX_FOLDER_ID;
            self.showPasswordTips = mailIndex.encryptId && mailData.selfMailFlag && (mailIndexFolderId === enums.FolderType.DRAFT_BOX_FOLDER_ID || mailIndexFolderId === enums.FolderType.SEND_BOX_FOLDER_ID);
            self.showRacallAllSuccess = mailIndexFolderId === enums.FolderType.SEND_BOX_FOLDER_ID && mailIndex.undoSend === enums.MailUndoSendType.ALL_SUCC;
            self.showRacallAllFail = mailIndexFolderId === enums.FolderType.SEND_BOX_FOLDER_ID && mailIndex.undoSend === enums.MailUndoSendType.ALL_FAIL;
            self.showRacallPartSuccess = mailIndexFolderId === enums.FolderType.SEND_BOX_FOLDER_ID && mailIndex.undoSend !== enums.MailUndoSendType.UNKNOWN  && mailIndex.undoSend !== enums.MailUndoSendType.NO_UNDO && mailIndex.undoSend !== enums.MailUndoSendType.ALL_SUCC && mailIndex.undoSend !== enums.MailUndoSendType.ALL_FAIL;
            // console.log(mailIndex.primeSender === self.localUserInfo.primeUserEmail);
            // console.log(mailIndex.folderId);
            // console.log(mailData.selfMailFlag);

            let starObj = {starred: mailIndex.starred};
            mailData = {...mailData, ...starObj};
            self.mailContData = mailData;
            self.mailContIndex = mailIndex;
            self.$store.commit('SET_MAIL_DATA', mailData);
            self.$store.commit('SET_MAIL_INDEX', mailIndex);
            self.$store.commit('SET_ACROSS_COUNT',0);
            self.$store.commit('SET_ACROSS_FLAG', false);
            self.$EventBus.$emit("cancelListCheckAll");
            // self.allAddrs = [...mailData.to, ...mailData.cc, ...mailData.bcc];
            // console.log(self.allAddrs)
            loading.close();
            //更新邮件列表的邮件状态
            let indexListData = self.$store.getters.indexListData;
            let newList = indexListData.map((item) => {
              if (mId === item.mailIndexId) {
                item.seen = true;
                self.$EventBus.$emit("refreshFolders");
              }
              return item
            });
            self.$store.commit('SET_INDEX_DATA', newList);
            //回执
            if (mailRead === false && mailData.needReceipt) {
              self.$confirm(self.$i18n.t('wm_lang_46323b'), self.$i18n.t('wm_lang_c45357'), {
                confirmButtonText: self.$i18n.t('wm_lang_38cf16'),
                cancelButtonText: self.$i18n.t('wm_lang_625fb2'),
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                (function (api, enums, pms) {
                  let spm = pms.MailFile.sendMailReceiptParamBuilder();
                  spm.mailIndexId = mailData.mailIndexId;
                  spm.from = mailData.from;
                  spm.subject = mailData.subject;
                  api.MailFile.sendMailReceipt(spm, function (res) {
                    console.log(res)
                    if(res.data.code === 0) {
                      self.$message({
                        type: 'success',
                        message: self.$i18n.t('wm_lang_05dfc3')+'!'
                      });
                    }
                  })
                })(xmail.api, xmail.enums, xmail.pms);
              }).catch(() => {
                self.$message({
                  type: 'info',
                  message: self.$i18n.t('wm_lang_5719f5')
                });
              });
            }
            //草稿隐藏快捷回复
            let mailContIndexFolderId = belongRootFolderId(self.mailContIndex.folderId, self.$store.getters.folders);
            if(mailContIndexFolderId === xmail.enums.FolderType.DRAFT_BOX_FOLDER_ID) {
              self.quickReplyEnable = false;
            } else {
              if(mailData.from === 'postmaster') {
                self.quickReplyEnable = false;
              } else {
                self.quickReplyEnable = true;
              }
            }
            //代发提醒
            if(mailData.realSender) { //系统退信情况realSender为空
              self.mailIsInstead = emailPart(mailData.realSender, 'email').toLowerCase() !== emailPart(mailData.from, 'email').toLowerCase();
            } else {
              self.mailIsInstead = false;
            }
            //判断非常用联系人
            self.strangerRemindFlag = (mailIndex.attrFlag & xmail.flags.MailIndexAttrFlag.UNBELONGCONTACTS_VAL) !== 0;
            //信体中a标签target设置
            setTimeout(() => {
              self.linkTargetSet();
            },500);
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    bytesToSize(bytes) {
      return bytesToSize(bytes)
    },
    matchAttachIcon(name) {
      return matchAttachIcon(name)
    },
    formatDate(val) {
      return formatDate(val)
    },
    // 附件下载
    attachDownUrl(downUrl) {
      return decodeURIComponent(downUrl);
    },
    // 附件预览
    attachPreview(attach){
      if(this.configSetting.deliverSetting.previewServerType !== xmail.enums.PreviewServerType.YOZO){
        const{ href } = this.$router.resolve({name:"AttachPreview", query:{downloadUrl: attach.previewOfficeUrl, previewUrl: attach.previewUrl, attachId: attach.fileId,
            attachName: attach.fileName, attachSize: attach.size, previewServerDomainName: attach.previewServerDomainName, previewServerOnOff: this.configSetting.deliverSetting.previewServerOnOff}});
        const openWin = window.open(href,'_blank');
        setTimeout(() => {
          openWin.document.title = attach.fileName
        }, 300)
      } else {
        let fType = attach.fileName.split('.').pop();
        let allowTypes = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt","html","xml", "pdf", "zip", "rar", "7z", "tar", "gz", "jpg", "jpeg", "png", "bmp", "gif"];
        if(!allowTypes.includes(fType)) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('文件类型不支持预览')
          });
          return;
        }
        (function (api, enums, pms) {
          let pm = pms.File.previewAllAttachFileParamBuilder();
          pm.downloadUrl = attach.previewOfficeUrl;
          pm.fileName = attach.fileName;
          api.File.previewAllAttachFile(pm, function (res) {
            // console.log(res.data);
            if(res.data.code === 0) {
              window.open(res.data.data.viewUrl,'_blank');
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }
    },
    /**
     * 查看信头
     * @param emailId
     */
    mailHeadInfo(mailIndexId) {
      let readThis = this;
      let params = xmail.pms.MailFile.getMailHeadInfoParamBuilder();
      params.mailIndexId = mailIndexId;

      xmail.api.MailFile.getMailHeadInfo(params, function (res) {
        readThis.mailHeadInfoStr = res.data.data.mailHead;
        readThis.mailHeadDialogVisible = true;
      });
    },

    /**
     * 邮件另存EML下载
     * @param folderId
     * @param emailId
     */
    mailSaveAsToStream(mailIndexId) {
      console.log(this.$i18n.t('wm_lang_5ce1e1'));
      const urlParams = storeLocal.get('Pwm-urlParams');
      let params = {
        mailIndexIds: [mailIndexId]
      };
      let url = '/xmail/wm/v1/mail/mailToStream'+ urlParams;
      downloadFile(url, params);
      // 创建form
      // let form = document.createElement('form');
      // form.id = 'form';
      // form.name = 'form';
      // document.body.appendChild(form);
      // // 循环创建input框
      // for (let index in params) {
      //   if (params.hasOwnProperty(index)) {
      //     let input = document.createElement('input')
      //     input.type = 'hidden'
      //     input.name = index;
      //     input.value = params[index]
      //     form.appendChild(input)
      //   }
      // }
      // form.target = "_blank";
      // form.method = 'post';
      // // 这里要支持json格式提交就好了？
      // // form.enctype = '';
      // // todo 这里是个问题，这种不能使用Ajax提交表单，这个地址难道写死吗？
      // form.action = "/xmail/wm/v1/mail/mailToStream" + urlParams;
      // form.submit();
      // document.body.removeChild(form);
    },
    writeFor(email) {
      this.$router.push({name: 'write', params: {type: 'write', addr: email}});
    },
    nodeDept(targetNode) {
      let department = "";
      if (targetNode) {
        if (typeof targetNode.parent !== "undefined") {
          let parentPath = this.nodeDept(targetNode.parent);
          department = parentPath ? parentPath + '/' + targetNode.name : targetNode.name;
        }
      }
      return department;
    },
    getAddrDept(addr) {
      let self = this;
      let deptPaths = '';
      Algorithm.depthWorker(this.orgTrees, function (node) {
        if (node.email === addr) {
          deptPaths += (deptPaths ? '; ' : '') + self.nodeDept(node.parent);
        }
      });
      return deptPaths;
    },
    userInfoCard(item,type) {
      // console.log(item)
      // console.log(type)
      if(!item) {
        return;
      }
      let infoItem = '';
      let isFull = item.indexOf("<") !== -1;
      let addr = '', name = '';
      if( isFull ){
        name = item.split('<')[0];
        addr = item.split('<')[1];
        addr = addr.substring(0,addr.length-1);
      } else {
        addr = item;
      }
      switch (type) {
        case 'name':
          infoItem = name;
          break;
        case 'email':
          infoItem = addr;
          break;
        case 'department':
          infoItem = this.getAddrDept(addr);
          break;
      }
      return infoItem;
    },
    linkTargetSet() {
      let mailText = document.getElementById('mailTextWrapper');
      if(!mailText) {
        return;
      }
      let ar = mailText.getElementsByTagName('a');
      let area = mailText.getElementsByTagName('area');
      // console.log(ar);
      // console.log(Array.from(ar))
      for (let i = 0; i < ar.length; i++) {
        if (ar[i].target !== '_blank') {
          ar[i].target = '_blank';
        }
      }
      for (let i = 0; i < area.length; i++) {
        if (area[i].target !== '_blank') {
          area[i].target = '_blank';
        }
      }
    }
  },
  computed: {
    selectedMail() {
      return this.$store.getters.checkedMails.length > 0
    },
    selectedOneMail() {
      return this.$store.getters.checkedMails.length === 1
    },
    currRoute() {
      return this.$route.name;
    }
  },
  watch: {
    $route(to, from) {
      // console.log(from);
      // console.log(to);
      if(to.name === 'read' || to.name === 'newRead') {
        let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
        if(from.name === 'write' && storeRootFolderId === xmail.enums.FolderType.DRAFT_BOX_FOLDER_ID) {
          return;
        }
        if(to.name === 'read' && this.layoutType === 'tb') {
          return;
        }
        this.getMailCont();
      }
    }
  },
  mounted() {
    this.getMailCont();
    this.configSetting = storeLocal.get('Pwm-configSetting');
    let self = this;
    /*
    重新读信
    */
    this.$EventBus.$off("refreshMailInfo");
    this.$EventBus.$on("refreshMailInfo",function(data){
      // console.log(data)
      self.getMailCont();
    });
    /*
    更新布局设置
    */
    this.$EventBus.$off("changeReadLayoutSet");
    this.$EventBus.$on("changeReadLayoutSet",function(data){
      // console.log(data)
      self.layoutType = data.layout;
    });

    this.$globalClick(() => {
      if(this.form.desc === '') {
        this.showQuickReply = false;
        this.quickReplyHeigh = false;
      }
    }, 'mainLayoutBox', 'quickReplyWrapper');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/layout/boxRead.vue